
<div class="error401Wrapper">
    <div class="error401Container">
        <h1>401</h1>
        <p>UNAUTHORISED</p>
        <button (click)="goBack()">{{buttonTitle}}</button>
    </div>
</div>